import { MatchageConstantesComponent } from "./MatchageConstantes";
import { MatchageScoringConstantesComponent } from "./MatchageScoringConstantes";

export const ConstantesConfigRoutes = [{
    path: '/constantesconfig/matchage',
    element: <MatchageConstantesComponent />,
    role: 'Pocahontas_ConstantesConfig'
},
    {
        path: '/constantesconfig/scoring',
        element: <MatchageScoringConstantesComponent />,
        role: 'Pocahontas_ConstantesConfig'
    }]